"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleBlock = void 0;
var bem_cn_1 = require("bem-cn");
exports.styleBlock = bem_cn_1.setup({
    ns: "kit__",
    mod: "--",
});
//# sourceMappingURL=index.js.map